/**
 * AQUAS Hero Slider
 * Handles slide transitions, dot navigation, and auto-rotation
 */

class AquasHeroSlider {
  constructor(element) {
    this.slider = element;
    if (!this.slider) return;

    this.slides = this.slider.querySelectorAll('.aquas-hero-slide');
    this.dots = this.slider.querySelectorAll('.aquas-hero-dot');
    this.currentIndex = 0;
    this.autoRotate = this.slider.dataset.autoRotate === 'true';
    this.rotateSpeed = parseInt(this.slider.dataset.rotateSpeed) || 5000;
    this.intervalId = null;

    this.init();
  }

  init() {
    if (this.slides.length <= 1) return;

    // Add click handlers to dots
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });

    // Start auto-rotation if enabled
    if (this.autoRotate) {
      this.startAutoRotate();

      // Pause on hover
      this.slider.addEventListener('mouseenter', () => this.stopAutoRotate());
      this.slider.addEventListener('mouseleave', () => this.startAutoRotate());
    }

    // Show first slide
    this.showSlide(0);
  }

  goToSlide(index) {
    this.showSlide(index);

    // Reset auto-rotation timer
    if (this.autoRotate) {
      this.stopAutoRotate();
      this.startAutoRotate();
    }
  }

  showSlide(index) {
    // Remove active class from all slides and dots
    this.slides.forEach(slide => slide.classList.remove('active'));
    this.dots.forEach(dot => dot.classList.remove('active'));

    // Add active class to current slide and dot
    this.slides[index].classList.add('active');
    if (this.dots[index]) {
      this.dots[index].classList.add('active');
    }

    this.currentIndex = index;
  }

  nextSlide() {
    const nextIndex = (this.currentIndex + 1) % this.slides.length;
    this.showSlide(nextIndex);
  }

  startAutoRotate() {
    this.intervalId = setInterval(() => this.nextSlide(), this.rotateSpeed);
  }

  stopAutoRotate() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}

// Initialize all hero sliders on the page
function initHeroSliders() {
  const sliders = document.querySelectorAll('.aquas-hero-slider');
  sliders.forEach(slider => new AquasHeroSlider(slider));
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHeroSliders);
} else {
  initHeroSliders();
}
